import { BREAKPOINT_1_COLUMNS } from "@/app/(browse)/for-sale/sections/SearchLayoutConstants";
import { Divider } from "@mui/material";

export function AspectDivider() {
  return (
    <Divider
      sx={(theme) => ({
        display: "none",
        [theme.breakpoints.down(BREAKPOINT_1_COLUMNS)]: {
          display: "block",
        },
      })}
    />
  );
}
